import CryptoJS from 'crypto-js';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../redux/hooks';
import {userDetails} from '../redux/features/auth/authSlice';
import {useEffect, useState} from 'react';
import PreLoader from '../components/Loaders/Preloader';
import Header from '../components/Auth/Header';
import {AuthCard} from '../styles/auth.styles';

const AuthLayout = () => {
    const [showOutlet, setShowOutlet] = useState(false);

    const navigate = useNavigate();

    const dispatch = useAppDispatch();

    const {details, token} = useAppSelector(state => state.auth);

    const decryptedToken =
        new URLSearchParams(useLocation().search).get('token') || null;

    const confirmLogin = async () => {
        if (details?.id && token) {
            navigate('/app');
        } else {
            if (decryptedToken) {
                let token = decryptedToken.replace(/\s/g, '+');
                let bytes = CryptoJS.AES.decrypt(token, 'getripay');
                const decrypted = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                if (decrypted.token) {
                    localStorage.setItem('@token', decrypted.token);
                    dispatch(
                        userDetails({
                            token: decrypted.token,
                            id: decrypted.user_id,
                        }),
                    );
                } else {
                    setShowOutlet(true);
                }
            } else {
                setShowOutlet(true);
            }
        }
    };

    useEffect(() => {
        confirmLogin();
    }, []);

    useEffect(() => {
        if (details?.id) {
            navigate('/app');
        }
    }, [details]);

    return showOutlet ? (
        <div>
            <Header show={true} />
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-lg-7">
                        <AuthCard className="shadow-sm">
                            <Outlet />
                        </AuthCard>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className="mt-5 pt-5 text-center">
            <PreLoader />
        </div>
    );
};

export default AuthLayout;
